// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  width: 100vw;
  max-width: 430px; /* iPhone 12 Pro Max width, adjust as needed */
  margin: 0 auto; /* Center the settings container */
  height: 100vh; /* Full height */
  background-color: #fff; /* White background like iOS */
  overflow-y: auto; /* Enable scrolling if content is longer than the screen */
  overflow-x: hidden;
  /* border-radius: 40px;  */
}



.search-compose {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}




.messages-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: fixed;
  width: 100vw;
  max-width: 424px;
  /* height: 5.5em; */
  justify-content: space-between;
  padding-bottom: 10px;
  background-color: #f8f8f7;
  border-bottom: 1px solid #ddd;
}

.buttontop {
  /* position: fixed;
  top: 10px;
  right: 10px; */
  margin-left: 90%;
  z-index: 9999;
}

.messages-header h1 {
  font-size: 32px;
  margin: 0;
  padding-left: 15px;
  padding-top: 10px;
}

.messages-header input {
  flex-grow: 1;
  margin: 0 10px;
  padding: 10px;
  border: none;
  border-radius: 10px;
  width: 90%;
}

.message-list {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-top: 125px;
}

.message-item {
  display: flex;
  align-items: center; /* Vertical alignment */
  padding: 10px;
  border-bottom: 1px solid #ddd;
}



.message-icon {
border-radius: 50%;
width: 40px;
height: 40px;
display: flex;
justify-content: center;
align-items: center;
overflow: hidden;
margin-right: 10px;
background-color: #d1d1d1; /* Placeholder for icons without a specified color /
color: #fff;
font-size: 22px; / Adjust as needed */
}

.message-content {
  flex-grow: 1; /* Take available horizontal space */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Vertical alignment */
  align-items: flex-start; /* Horizontal alignment */
}

.message-name {
font-weight: bold;
font-size: 18px;
color: #000;
}

.message-preview {
font-size: 16px;
padding-left: 3px;
max-width: 260px;
color: #555;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}

.message-time {
color: #999;
font-size: 14px;
padding-left: 10px;
white-space: nowrap; 
}

`, "",{"version":3,"sources":["webpack://./src/components/css/Messages.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB,EAAE,8CAA8C;EAChE,cAAc,EAAE,kCAAkC;EAClD,aAAa,EAAE,gBAAgB;EAC/B,sBAAsB,EAAE,8BAA8B;EACtD,gBAAgB,EAAE,0DAA0D;EAC5E,kBAAkB;EAClB,0BAA0B;AAC5B;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;;;;AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;;gBAEc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,uBAAuB;EAC5C,aAAa;EACb,6BAA6B;AAC/B;;;;AAIA;AACA,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,gBAAgB;AAChB,kBAAkB;AAClB,yBAAyB,EAAE;;qCAEU;AACrC;;AAEA;EACE,YAAY,EAAE,oCAAoC;EAClD,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,uBAAuB;EAChD,uBAAuB,EAAE,yBAAyB;AACpD;;AAEA;AACA,iBAAiB;AACjB,eAAe;AACf,WAAW;AACX;;AAEA;AACA,eAAe;AACf,iBAAiB;AACjB,gBAAgB;AAChB,WAAW;AACX,mBAAmB;AACnB,gBAAgB;AAChB,uBAAuB;AACvB;;AAEA;AACA,WAAW;AACX,eAAe;AACf,kBAAkB;AAClB,mBAAmB;AACnB","sourcesContent":[".messages {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  width: 100vw;\n  max-width: 430px; /* iPhone 12 Pro Max width, adjust as needed */\n  margin: 0 auto; /* Center the settings container */\n  height: 100vh; /* Full height */\n  background-color: #fff; /* White background like iOS */\n  overflow-y: auto; /* Enable scrolling if content is longer than the screen */\n  overflow-x: hidden;\n  /* border-radius: 40px;  */\n}\n\n\n\n.search-compose {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n}\n\n\n\n\n.messages-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: fixed;\n  width: 100vw;\n  max-width: 424px;\n  /* height: 5.5em; */\n  justify-content: space-between;\n  padding-bottom: 10px;\n  background-color: #f8f8f7;\n  border-bottom: 1px solid #ddd;\n}\n\n.buttontop {\n  /* position: fixed;\n  top: 10px;\n  right: 10px; */\n  margin-left: 90%;\n  z-index: 9999;\n}\n\n.messages-header h1 {\n  font-size: 32px;\n  margin: 0;\n  padding-left: 15px;\n  padding-top: 10px;\n}\n\n.messages-header input {\n  flex-grow: 1;\n  margin: 0 10px;\n  padding: 10px;\n  border: none;\n  border-radius: 10px;\n  width: 90%;\n}\n\n.message-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  margin-top: 125px;\n}\n\n.message-item {\n  display: flex;\n  align-items: center; /* Vertical alignment */\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n}\n\n\n\n.message-icon {\nborder-radius: 50%;\nwidth: 40px;\nheight: 40px;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\noverflow: hidden;\nmargin-right: 10px;\nbackground-color: #d1d1d1; /* Placeholder for icons without a specified color /\ncolor: #fff;\nfont-size: 22px; / Adjust as needed */\n}\n\n.message-content {\n  flex-grow: 1; /* Take available horizontal space */\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Vertical alignment */\n  align-items: flex-start; /* Horizontal alignment */\n}\n\n.message-name {\nfont-weight: bold;\nfont-size: 18px;\ncolor: #000;\n}\n\n.message-preview {\nfont-size: 16px;\npadding-left: 3px;\nmax-width: 260px;\ncolor: #555;\nwhite-space: nowrap;\noverflow: hidden;\ntext-overflow: ellipsis;\n}\n\n.message-time {\ncolor: #999;\nfont-size: 14px;\npadding-left: 10px;\nwhite-space: nowrap; \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
